import AddIcon from '@mui/icons-material/Add';
import { Box, useTheme } from "@mui/material";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import Text from "../../../../../components/theme/text/Text";
import { tokens } from "../../../../../theme";

import { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import OrdersCard from "../../../../../components/global/cards/orders/OrdersCard";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetPickingJobPickingListQuery, useGetPickingJobsQuery } from "../../../../../newapi/pickingjob/pickingjobSlice";
import { general_states } from "../../../../../utils/staticEnums";

import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from '../../../../../components/theme/sidepanel2/SidepanelLoader';

const SpPickingJobPickingList = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpPickingJobPickingList/SpPickingJobPickingList"))

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,

};

const isShipmentDue = (inputDateString) => {
   const inputDate = new Date(inputDateString);
   const now = new Date();
  
    return now > inputDate;
  };

const OutboundBatchesFinished = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(-1);
    const [rowSelected, setRowSelected] = useState(false);
    
    const ref = useRef();
    const [config, setConfig] = useState({"state": general_states.COMPLETED});
    const [spLoading, setSpLoading] = useState();

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
        }
    },[]);

    const { data: pickingJobData, isLoading } = useGetPickingJobPickingListQuery(selectedRowId,
        {
            enabled: rowSelected && selectedRowId !== -1,
            skip: !rowSelected
        }
    );
    
    const getPickingList = (event, params) => { 
        if (!params || !params.row) return;

        event.stopPropagation();
        setSelectedRowId(params.id);
        setRowSelected(true);
        if(!spLoading) {
            setSpLoading(true);
        }
    };

    useEffect(() => {
        if (!isLoading && pickingJobData && rowSelected) {
            setIsExtended(true);
        }
    }, [pickingJobData, isLoading, rowSelected]);

    const columns = [
        {
            field: "id",
            headerName: t("reference"),
            shFilter : {
                type: "number",
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <Box 
                        sx={{
                            width:80,
                            cursor:"pointer",
                            lineHeight:"64px",
                        }} 
                        onClick={(event) => getPickingList(event, params.row.id)}
                    >
                        <Text clickable semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.id}</Text>
                    </Box>
                );
            }
        },
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }
                
                let labelcolor = "grey";
                switch(params.row.state){
                    case "in_progress":
                        labelcolor = theme.palette.mode === "dark" ? "blue" : "primary"
                        break;
                    case "completed":
                        labelcolor = "green"
                        break;
                    default:
                        labelcolor = "grey"
                        break;
                }
                
                return (
                    <ShLabel clickable size={32} palette="normal" variant={labelcolor}>
                      {params.row.state ? t(params.row.state) : t('unknown')}
                    </ShLabel>
                  );
              }
        },
        {field: "orderCount", headerName: t("pickinglists"),flex:1,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.row.orderCount
        }},
        {field: "totalProducts", headerName: t("products"),flex:1,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.row.total_products
        }},
        {field: "userName", headerName: t("appointed_to"),flex:1,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.row.userName
        }},
        {field: "warehouse", headerName: t("warehouse"),flex:1,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return params.row.warehouse.name;
        }},
        {field: "createdAt", headerName: t("created"),flex:1,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }

            let created = new Date(params.row.createdAt);
            return created.toLocaleDateString(i18n.language);
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <OrdersCard skeleton={params.row.skeleton ?? false} {...params.row}  />
                )
            }
        }
    ];

    const [selectedItems, setSelectedItems] = useState([]);
    // const setSelected
    const onSelected = (selectedItems) => {
        setSelectedItems(selectedItems);
    }

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetPickingJobsQuery}
                config={config}
                // gridActions={<GridActions></GridActions>} 
                title={t('finished')}
                gridOptions={gridOptions} 
                columns={columns}
                rows={data}
                onRowClick={getPickingList}
                sortModel={{field: columns[0].field,type:"DESC"}}>
            </ShDataGrid2>


            {spLoading && 
                <SpPickingJobPickingList
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    data={pickingJobData}
                /> 
            }
            
        </Box>
    );
}

export default OutboundBatchesFinished;